/* RESPONSIBLE TEAM: team-proactive-support */
import Route from '@ember/routing/route';

export default class CustomBotsSentRoute extends Route {
  parentRoute = 'apps.app.reports.customer-support.custom-bots';
  templateName = 'apps.app.reports.lead-generation.custom-bots.sent';
  controllerName = 'apps.app.reports.lead-generation.custom-bots.sent';
}
